import React, { FC } from 'react';
import { useStyles } from './styles';
import { Button, Grid } from '@material-ui/core';
import { useStore } from 'hooks/useRootStore';
import { Tooltip } from '@material-ui/core';
import { useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
const EndUserFooter: FC = () => {
  const classes = useStyles();
  const {
    endUserSettingsFormStore: { endUserConfigSettings, getPortalSettings },
  } = useStore();

  const getPortalSettingReq = useQuery('portalSettingsget', () => getPortalSettings(), {
    onError: () => console.error('Failed to fetch portal settings'),
  });

  const handleClick = (url: string) => {
    let constructedUrl: string;

    if (url.startsWith('http://') || url.startsWith('https://')) {
      constructedUrl = url;
    } else {
      constructedUrl = `http://${url}`;
    }

    try {
      const validatedUrl = new URL(constructedUrl);
      window.open(validatedUrl.toString(), '_blank');
    } catch (error) {
      console.error('Invalid URL:', error);
    }
  };

  useAppPreloader(getPortalSettingReq.isFetching);
  return (
    <>
      <Grid container className={classes.footer}>
        <Grid container className={classes.footerMargin}>
          <Grid item xs={6}>
            <ul className={classes.footerList}>
              {endUserConfigSettings?.homeUrl && (
                <Tooltip title={endUserConfigSettings?.homeUrl} placement='bottom'>
                  <Button
                    className={classes.ButtonCSS}
                    onClick={() => handleClick(endUserConfigSettings?.homeUrl as string)}
                  >
                    Home
                  </Button>
                </Tooltip>
              )}
              {endUserConfigSettings?.privacyPolicy && (
                <Tooltip title={endUserConfigSettings?.privacyPolicy} placement='bottom'>
                  <Button
                    className={classes.ButtonCSS}
                    onClick={() => handleClick(endUserConfigSettings?.privacyPolicy as string)}
                  >
                    Privacy Policy
                  </Button>
                </Tooltip>
              )}
              {endUserConfigSettings?.termOfUse && (
                <Tooltip title={endUserConfigSettings?.termOfUse} placement='bottom'>
                  <Button
                    className={classes.ButtonCSS}
                    onClick={() => handleClick(endUserConfigSettings?.termOfUse as string)}
                  >
                    Terms of Use
                  </Button>
                </Tooltip>
              )}
              {endUserConfigSettings?.contactUrl && (
                <Tooltip title={endUserConfigSettings?.contactUrl} placement='bottom'>
                  <Button
                    className={classes.ButtonCSS}
                    onClick={() => handleClick(endUserConfigSettings?.contactUrl as string)}
                  >
                    Contact Us
                  </Button>
                </Tooltip>
              )}
              {endUserConfigSettings?.helpUrl && (
                <Tooltip title={endUserConfigSettings?.helpUrl} placement='bottom'>
                  <Button
                    className={classes.ButtonCSS}
                    onClick={() => handleClick(endUserConfigSettings?.helpUrl as string)}
                  >
                    Help
                  </Button>
                </Tooltip>
              )}
            </ul>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default EndUserFooter;
